var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import api from '@/shared/api';
import config from '@/config';
export var SharepointFileSelector = function (_a) {
    var siteId = _a.siteId, driveId = _a.driveId, folderId = _a.folderId, selectedFileId = _a.selectedFileId, onFileSelected = _a.onFileSelected;
    var _b = useState([]), files = _b[0], setFiles = _b[1];
    useEffect(function () {
        if (!siteId || !driveId || !folderId)
            return;
        var url = !!folderId && folderId !== '/'
            ? "".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(siteId, "/drives/").concat(driveId, "/folders/").concat(folderId, "/files")
            : "".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(siteId, "/drives/").concat(driveId, "/files");
        api.base.get(url).then(function (x) { return setFiles(x.data); });
    }, [siteId, driveId, folderId]);
    return (_jsxs("select", __assign({ disabled: files.length < 1, onChange: function (e) { return onFileSelected(files.find(function (x) { return x.id === e.target.value; }).name, e.target.value); }, className: "form-control margin5B", value: selectedFileId }, { children: [_jsx("option", { value: null }), files.map(function (file) { return (_jsx("option", __assign({ value: file.id }, { children: file.name }), file.id)); })] })));
};
